import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import { adminUserKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface DeactivateAdminUserParams {
  adminUserId: string;
  reason: string;
}

export const useDeactivateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ adminUserId, reason }: DeactivateAdminUserParams) =>
      adminUsersApi.deactivateUser(adminUserId, { reason }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
      Notification.success({
        title: 'Usuario desactivado',
        description: 'El usuario ha sido desactivado exitosamente.',
      });
    },
  });
};
